import { connect } from 'react-redux';
import { Instances, SideBarTypes } from '../../../../constants';

import { IStateType } from '../../../../store/models/root.interface';
import { removeObject } from '../../../../store/Object';
import { updateObjects } from '../../../../store/Objects';
import {
	closeSideBar,
	getIsOpen,
	openSideBar,
} from '../../../../store/sidebar';
import APIKeyCreate, {
	DispatchPropsType,
	MapStatePropsType,
} from '../organisms/APIKeyCreate';

const mapStateToProps = (state: IStateType) => ({
	sidebarVisibility: getIsOpen(state),
});
const mapDispatchToProps = {
	onClose: () => {
		return closeSideBar([removeObject(Instances.APIKeyCreate)]);
	},
	OnSuccessCallSlider: (data: any) =>
		openSideBar(SideBarTypes.APIKeyCreateSuccess, data),
};

export default connect<
	MapStatePropsType,
	DispatchPropsType,
	unknown,
	IStateType
>(
	mapStateToProps,
	mapDispatchToProps
)(APIKeyCreate);
